import axios from "axios";
import StorageUtil, { KEYS } from "~/helpers/utils/StorageUtil";
import { decodeJWT } from "~/helpers/utils/Functions";
import ToastHelper, { STATUS_HELPER } from "~/helpers/ToastHelper";
/** Classe base que fará a comunicação com o backend.
 * Esta classe trata as configurações de headers, paths e todas as urls(endpoints) deverão ser inseridos aqui
 */
class BaseAPI {
  /** Métodos get */
  static async get(endpoint, data = {}) {
    const requestConfig = { params: data };
    return await api.get(endpoint, requestConfig);
  }

  /** Métodos post */
  static async post(endpoint, data = {}, config) {
    const requestConfig = { code: config };
    return await api.post(endpoint, data, requestConfig);
  }

  /** Método Put */
  static async put(endpoint, data = {}) {
    return await api.put(endpoint, data);
  }

  /** Método delete */
  static async delete(endpoint, data = {}) {
    return await api.delete(endpoint, { data });
  }

  /** Método Patch */
  static async patch(endpoint, data = {}) {
    return await api.patch(endpoint, data);
  }
}

/** URL de acordo ao protocolo, hostname e endpoint */
export const baseURL = () =>
  process.env.REACT_APP_API_URL || "https://tdb-api.dev.stoomlab.com.br";
//export const baseURL = () => 'http://localhost:8080';

// Cria uma instancia de api
const api = axios.create({ baseURL: baseURL(), withCredentials: true });

api.interceptors.request.use(
  (config) => {
    const token = StorageUtil.getItem(KEYS.TOKEN_KEY);
    config.headers = { "api-key": "tdbkey123" };
    if (config.method === "post" || config.method === "put") {
      config.headers = { "content-type": "application/json" };
    }
    if (config?.code?.headers?.code) {
      config.headers = { "2fa": config?.code?.headers?.code };
    }
    config.headers["api-key"] = "tdbkey123";
    config.headers.Marketplace = "tdb";
    if (token) {
      config.headers.Authorization = `${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Intercepta os retornos.
// TODO fazer a lógica do refresh token.
api.interceptors.response.use(
  (response) => {
    const token = response.headers.authorization;
    if (token) {
      const currentToken = response.headers.authorization.split(" ")[1];
      const decode = decodeJWT(currentToken);
      StorageUtil.setItem(KEYS.AUTH_KEY, decode.Authorities);
      StorageUtil.setItem(KEYS.TOKEN_KEY, currentToken);
    }
    return response;
  },
  (error) => {
    const toastHelper = new ToastHelper();
    if (error.response.status === 401) {
      toastHelper.notify(
        STATUS_HELPER.ERROR,
        "Sessão expirada, por favor, faça login novamente"
      );
      setTimeout(() => {
        StorageUtil.cleanAll();
        window.location.href = '/logout';
      }, 2000);
    }
    return Promise.reject(error);
  },
);

// Lista de todos os endpoints. Todos endpoints deverão ser inseridos aqui.
const MANAGER = "/manager";
export const URLS = {
  MANAGER,
  LOGIN: `/administrator/login`,
  ACCOUNTS: `${MANAGER}/administrator`,
  TREASURE_SEARCH: `treasures/search`,
  TREASURE: `/treasures`,
  CATEGORIES_FILES: `${MANAGER}/files/categories`,
  FILES: "/files",
  CUSTOMERS: `${MANAGER}/customer`,
  QUESTIONS: `${MANAGER}/questions`,
  EVALUATIONS: `${MANAGER}/evaluations`,
  FORGET_PASSWORD: `/administrator/forget-password`,
  FORGET_PASSWORD_UPDATE: `/administrator/forget-password/update`,

  ORDERS: `${MANAGER}/orders`,
  SEARCHORDERS: `${MANAGER}/orders`,
  MERCHANT: `${MANAGER}/merchants`,
  SUPPLIER: `${MANAGER}/suppliers`,
  AUTOMAKER: `${MANAGER}/automakers`,
  SHIPPING: `${MANAGER}/shipping-company`,
  APPLICATION: `${MANAGER}/applications`,
  PRODUCTS: `${MANAGER}/insumosHolambra-products`,
  CAMPAIGNS: `${MANAGER}/campaigns`,
  CATEGORIES: `${MANAGER}/categories`,
  PROPERTY: `${MANAGER}/properties`,
  CLASSES: `${MANAGER}/properties/classes`,
  PRE_ORDERS: `${MANAGER}/preorders`,
  INSTITUTIONAL: `${MANAGER}/institutional`,
  ZIPCODERANGE: `${MANAGER}/zipcode-range`,
  CUSTOMER_GROUP: `${MANAGER}/insumosHolambra-customers/types`,
  INSUMOS_HOLAMBRA: `${MANAGER}/insumosHolambra-customers`,
  BANNER: `${MANAGER}/banners`,

  NEWS_LETTER: `${MANAGER}/newsletters`,
  SALES: `${MANAGER}/reports/sales-general`,
  SALES_DETAILS: `${MANAGER}/reports/sales-details`,
};

export default BaseAPI;
